<template>
  <div>
    <div
      id="loading-grid"
      v-if="!loaded"
      style="margin: 10% 40%; position: absolute; z-index: 231"
    >
      <svg
        class="spinner"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
    <div id="cat" v-cloak :class="{ showhide: !loaded }">
      <div class="vx-card mb-4">
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <div class="vx-card__body card-body">
            <div class="vx-row">
              <div class="w-full px-4 flex gap-4 flex-wrap">
                <vs-button
                  @click="createItem()"
                  class="bg_l_green sm:flex-grow-0 flex-grow"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                    v-has-permission="permission150"
                  />
                  {{ $t("CreateNewItem") }}
                </vs-button>
                <div class="flex flex-grow justify-end gap-4">
                  <div class="flex">
                    <label class="custom-file-upload">
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                      />

                      <feather-icon
                        icon="PaperclipIcon"
                        svgClasses="h-4 w-4"
                        class="ico"
                      />
                      {{ $t("ChooseFile") }}
                      <span v-if="uploadedFileName" class="file-name">{{
                        uploadedFileName
                      }}</span>
                    </label>
                    <vs-button
                      @click="uploadFile()"
                      class="bg_m_green float-right"
                      v-if="fileUploaded"
                      :disabled="disabledBtn"
                      v-has-permission="permission152"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="h-4 w-4"
                        class="ico"
                      />
                      {{ $t("UploadFile") }}
                    </vs-button>
                  </div>
                  <vs-button
                    @click="downloadFile()"
                    class="bg_purple float-right"
                    v-has-permission="permission151"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      svgClasses="h-4 w-4"
                      class="ico"
                    />
                    {{ $t("DownloadExcelFile") }}
                  </vs-button>
                  <div class="flex">
                    <div class="w-full">
                      <vs-button
                        @click="showFilters = !showFilters"
                        class="bg_purple float-right"
                      >
                        <div class="px-3">
                          <feather-icon
                            icon="FilterIcon"
                            svgClasses="h-4 w-4"
                            class="ico"
                          />
                          {{ $t("Filter") }}
                        </div>
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row" v-if="showFilters">
              <div class="w-full px-4">
                <div class="flex flex-wrap pt-2 gap-y-2">
                  <div class="lg:w-1/4 md:w-1/3 w-full md:pl-4">
                    <div class="w-full">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.Name"
                        :label="$t('ProductName')"
                        @keyup.enter="submitFilter()"
                      />
                    </div>
                  </div>
                  <div class="lg:w-1/4 md:w-1/3 w-full md:pl-4">
                    <div class="w-full">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.ModelNumber"
                        :label="$t('ModelNumber')"
                        @keyup.enter="submitFilter()"
                      />
                    </div>
                  </div>
                  <div class="lg:w-1/4 md:w-1/3 w-full md:pl-4">
                    <div class="w-full">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.ItemCode"
                        :label="$t('ItemCode')"
                        @keyup.enter="submitFilter()"
                      />
                    </div>
                  </div>
                  <div class="lg:w-1/4 md:w-1/3 w-full md:pl-4">
                    <label class="vs-input--label">{{
                      $t("GenericProduct")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="genericProducts"
                        v-model="gridSearchData.GenericProductId"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="lg:w-1/4 md:w-1/3 w-full md:pl-4">
                    <label class="vs-input--label">{{ $t("Color") }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="colorList"
                        v-model="gridSearchData.ColorId"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="lg:w-1/4 md:w-1/3 w-full md:pl-4">
                    <label class="vs-input--label">{{ $t("Warranty") }}</label>
                    <div class="w-full">
                      <v-select
                        label="childNameWithParentName"
                        :options="warrantyList"
                        v-model="gridSearchData.WarrantyId"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="lg:w-1/2 w-full flex items-end justify-end gap-4 pt-4"
                  >
                    <vs-button
                      type="filled"
                      color="#3ec9d6"
                      @click.prevent="resetForm"
                      >{{ $t("ResetFilter") }}</vs-button
                    >
                    <vs-button type="filled" @click.prevent="submitFilter()">{{
                      $t("SubmitFilter")
                    }}</vs-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row pt-4">
              <div class="vx-col w-full mb-base">
                <data-grid
                  ref="grid"
                  stripe
                  :data-source="gridDataSource"
                  :search-data="gridSearchData"
                  :columns="[
                    { title: $t('ProductName'), sort: 'ProductName' },
                    { title: $t('DepartmentName'), sort: 'DepartmentName' },
                    { title: $t('ProductCode'), sort: 'ItemCode' },
                    { title: $t('WarrantyName'), sort: 'WarrantyName' },
                    { title: $t('ProductColorName'), sort: 'ProductColorName' },
                    { title: $t('ItemCode'), sort: 'ItemCode' },
                    {
                      title: $t('IdentificationCode'),
                      sort: 'IdentificationCode',
                    },
                    {
                      title: $t('guranteeIdentification'),
                      sort: 'guranteeIdentification',
                    },
                    { title: $t('ModelNumber'), sort: 'ModelNumber' },
                    { title: $t('Action') },
                  ]"
                >
                  <template slot-scope="{ row }">
                    <td style="width: 25%">
                      {{ row.persianName }}
                    </td>
                    <td style="width: 12%">
                      {{ row.genericProductName }}
                    </td>
                    <td style="width: 8%">{{ row.actualProductId }}</td>
                    <td style="width: 16%">
                      {{ row.warrantyName }}
                    </td>
                    <td style="width: 5%">
                      {{ row.productColorName }}
                    </td>
                    <td style="width: 10%">
                      {{ row.itemCode }}
                    </td>
                    <td style="width: 7%">
                      {{ row.identificationCode }}
                    </td>
                    <td style="width: 7%">
                      {{ row.guaranteeIdentification }}
                    </td>
                    <td style="width: 14%">
                      {{ row.modelNumber }}
                    </td>
                    <td style="width: 5%">
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        @click.prevent="editSpecificProduct(row)"
                        class="mx-auto d-inline"
                        v-has-permission="permission154"
                      ></vs-button>
                    </td>
                  </template>
                </data-grid>
              </div>
            </div>
            <modify-popup
              :show="ModifyPopup"
              :model="model"
              @finish="onfinish"
              @close="closeModifyPopup"
              :colorList="colorList"
              :countryList="countryList"
              :warrantyList="warrantyList"
            ></modify-popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.showhide {
  opacity: 0.5;
  z-index: 1;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
import vSelect from "@/components/CustomVSelect.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: {
    ModifyPopup,
    DataGrid,
    "v-select": vSelect,
  },
  data() {
    return {
      permission150: "CreateSpecificProduct",
      permission151: "GetAllSpecificProductsByExcelFIle",
      permission152: "CreateSpecificProductByExcelFile",
      permission153: "DeleteSpecificProduct",
      permission154: "ModifySpecificProduct",
      loaded: true,
      ModifyPopup: false,
      model: {},
      showFilters: false,
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/SpecificProductsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      updateLoading: false,
      uploadedFileName: "",
    };
  },
  mounted() {
    this.fetchGenericProducts();
    this.fetchColors();
    this.fetchWarranties();
  },
  computed: {
    ...mapGetters({
      allSpecificProducts: "specificProduct/list",
      genericProducts: "genericProduct/list",
      colorList: "color/list",
      countryList: "country/list",
      warrantyList: "warranty/list",
    }),
  },

  methods: {
    ...mapActions({
      fetchSpecificProducts: "specificProduct/fetch",
      fetchGenericProducts: "genericProduct/fetch",
      importSpecificProducts: "excel/importSpecificProducts",
      exportSpecificProducts: "excel/exportSpecificProducts",
      removeSpecificProduct: "specificProduct/remove",
      fetchColors: "color/fetchMinify",
      fetchCountry: "country/fetch",
      fetchWarranties: "warranty/fetchMinify",
    }),
    createItem() {
      this.model = {};
      this.ModifyPopup = true;
      this.fetchColors();
      this.fetchCountry();
      this.fetchWarranties();
    },
    editSpecificProduct(model) {
      this.model = {
        id: model.id,
        actualProductId: model.persianName,
        actualProductIdPrevious: model.actualProductId,
        actualProductNamePrevious: model.persianName,
        warrantyId: model.warrantyId,
        productColorId: model.productColorId,
        itemCode: model.itemCode,
        modelNumber: model.modelNumber,
        countryId: model.countryInfo ? model.countryInfo.countryId : null,
        countryName: model.countryInfo ? model.countryInfo.countryName : null,
        description: model.description,
        identificationCode: model.identificationCode,
        guaranteeIdentification: model.guaranteeIdentification,
      };
      this.ModifyPopup = true;
      this.fetchColors();
      this.fetchCountry();
      this.fetchWarranties();
    },
    downloadFile() {
      this.loaded = false;
      this.exportSpecificProducts().then(() => {
        setTimeout(() => {
          this.loaded = true;
        }, 0);
      });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    uploadFile() {
      this.loaded = false;
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);

      this.importSpecificProducts(formData).then(() => {
        this.updateLoading = true;
        setTimeout(() => {
          this.$refs.grid.renderGrid();
          this.updateLoading = false;
          this.uploadedFileName = "";
        }, 5000);
      });
      setTimeout(() => {
        this.disabledBtn = false;
        this.loaded = true;
      }, 1000);
    },
    deleteSpecificProduct(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeSpecificProduct(id).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        Name: "",
        ModelNumber: "",
        ItemCode: "",
        GenericProductId: "",
        ColorId: "",
        WarrantyId: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
